import script from "./GalleryGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalleryGrid.vue?vue&type=script&lang=ts&setup=true"

import "./GalleryGrid.vue?vue&type=style&index=0&id=2925e03e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2925e03e"]])

export default __exports__